import { render, staticRenderFns } from "./Reportes_old2.vue?vue&type=template&id=95372054&"
import script from "./Reportes_old2.vue?vue&type=script&lang=js&"
export * from "./Reportes_old2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports